// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"162d55fa","909":"947df860","963":"9a43f47a"}[chunkId] + ".chunk.js";
};